import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { withRouter } from 'react-router-dom';
import Utils from 'screens/shared/utilities';
import Dropdown from './select-field';

export default withRouter(({ onChange = null, error = '', match }) => {
  const { dcId } = match.params;
  const [selectedServer, setSelectedServer] = useState('');
  const [selectedNic, setSelectedNic] = useState('');
  const { [ACTIONS_TYPES.DATA_CENTER.GET]: dataCenter = {} } = useSelector((e) => e);
  const items = dataCenter?.entities?.servers?.items || [];
  const nics = selectedServer?.entities?.nics?.items || [];

  useEffect(() => {
    actions.dataCenter.get({ id: dcId });
  }, [dcId]);

  const serverChangeHandler = (e) => {
    setSelectedServer(items.find(({ id }) => id === e.target.value));
    setSelectedNic('');
    onChange('');
  };

  const nicChangeHandler = (e) => {
    onChange(e.target.value);
    setSelectedNic(e.target.value);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10 }}>
      <Dropdown
        values={items.map((e) => [e?.id, <Utils.IconLabel icon="server" label={e?.properties?.name} />])}
        label="Select a Server"
        onChange={serverChangeHandler}
        value={selectedServer?.id}
        error={error && !selectedServer ? error : ''}
      />
      <Dropdown
        values={nics.map((e, i) => [e?.id, <Utils.IconLabel icon="ethernet" label={`NIC ${i} ${e?.properties?.name}`} />])}
        label="Select a NIC"
        onChange={nicChangeHandler}
        value={selectedNic}
        error={error && !selectedNic ? error : ''}
      />
    </div>
  );
});
